<template>
  <slot></slot>
</template>

<script setup>
import { useResizeObserver } from "@vueuse/core";
import { onMounted, ref } from "vue";
import { useMenuRowSelection } from "./composables/useMenuRowSelection";
import { useHostElement } from "#ce/composables/useHostElement";

const ACTIVE_STICKY_COLUMN_CLASS = "--active-sticky-column";
const TABLE_SELECTOR = "table.sticky-table-columns";

// The element sits beside the table it marks. A table slotted into a shadow root resolves
// `width: 100%` against its own max-content instead of the scroll container.

const host = useHostElement();
const container = ref(null);
const table = ref(null);

function markOverflow([entry]) {
  const overflows = container.value.getBoundingClientRect().width < entry.contentRect.width;
  entry.target.classList.toggle(ACTIVE_STICKY_COLUMN_CLASS, overflows);
}

function findTable() {
  container.value = host?.parentElement ?? null;
  table.value = container.value?.querySelector(TABLE_SELECTOR) ?? null;
}

onMounted(findTable);

useResizeObserver(table, markOverflow);
useMenuRowSelection(container);
</script>

<style>
:host {
  display: none;
}
</style>
